const ids = require('./ids');

module.exports = {
	...ids,
	name: 'stores'
};
